import { useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FaviconLoader = () => {
  useEffect(() => {
    loadFavicon();
  }, []);

  const loadFavicon = async () => {
    try {
      const res = await axios.get(`${API}/favicon`);
      if (res.data.favicon_url) {
        // Update favicon link
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }
        link.href = `${BACKEND_URL}${res.data.favicon_url}`;
        
        // Also update apple-touch-icon if exists
        let appleLink = document.querySelector("link[rel='apple-touch-icon']");
        if (appleLink) {
          appleLink.href = `${BACKEND_URL}${res.data.favicon_url}`;
        }
      }
    } catch (error) {
      console.error("Error loading favicon:", error);
    }
  };

  return null;
};

export default FaviconLoader;
